define("settings/routes/groups/group/members", ["exports", "@ember/routing/route"], function (_exports, _route) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route"eaimeta@70e063a35619d71f
  class MembersRoute extends _route.default {
    model() {
      return this.modelFor('groups.group');
    }
    setupController(controller, model) {
      controller.setProperties({
        group: model
      });
    }
  }
  _exports.default = MembersRoute;
});